module.exports = __webpack_public_path__ + "static/media/pen.efa7b53a.svg";